import React, { useEffect, useState } from "react";
import {
  DiReact,
  DiMongodb,
  DiVisualstudio,
  DiGit,
  DiDocker,
  DiHeroku,
  DiCss3,
  DiHtml5,
  DiPython,
  DiNodejsSmall,
  DiBootstrap,
  DiDjango,
  DiJsBadge,
  DiWordpress,
  DiPhotoshop,
  DiGithubBadge,
  DiNpm,
  DiTerminal,
  DiCodepen,
} from "react-icons/di";
import classes from "./Portfolio.module.css";
import { FaTools } from "react-icons/fa";
import "react-circular-progressbar/dist/styles.css";

// Animation
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "./AnimatedProgressProvider";
import Aos from "aos";
import "aos/dist/aos.css";
import ProjectCard from "./ProjectCard/ProjectCards";
import { projects } from "../../../constants/constants";

const Project = () => {
  useEffect(() => {
    Aos.init({
      duration: 2000,
      easing: "ease-in-sine",
      mirror: true,
      disable: "mobile",
    });
  });

  return (
    <div className={classes.projectContainer} id="portfolioId">
      <div data-aos="fade-right">
        <h1>
          Portfolio <span className={classes.line}></span>
        </h1>
      </div>

      {/* Career Section with Tools */}
      <div className={classes.container} data-aos="fade">
        <div className={classes.career}>
          <h2>Why I chose Web Developement as a Career? &#129300;</h2>
          <p>
            I'm a versatile person with a lot of experience in the tech
            community. I've attended 10+ workshops in the past year on a variety
            of topics ranging from machine learning to UI/UX and Web
            Developement. I like designing & building websites for users that
            will help them. I gained some intrest in this Field after my 1st
            year engineering and after couple of years i excelled well and
            pursing it as a career. Hire me for in-time service with best
            results possible ¯\_(ツ)_/¯.
          </p>
          <div>
            <h2 className={classes.toolh2}>
              <FaTools style={{ marginRight: "0.5rem" }} /> Tools
            </h2>
            <div>
              <div className={classes.tools}>
                <DiDocker
                  size={"2.5em"}
                  color={"grey"}
                  style={{ color: "#0db7ed" }}
                  className={classes.toolicons}
                />
                <div className={classes.label}>Docker</div>
              </div>
              <div className={classes.tools}>
                <DiVisualstudio
                  size={"2.5em"}
                  color={"grey"}
                  style={{ color: "blue" }}
                  className={classes.toolicons}
                />
                <div className={classes.label}>VSCode</div>
              </div>
              <div className={classes.tools}>
                <DiPhotoshop
                  size={"2.5em"}
                  color={"grey"}
                  style={{ color: "#707894" }}
                  className={classes.toolicons}
                />
                <div className={classes.label}>Photoshop</div>
              </div>
              <div className={classes.tools}>
                <DiGithubBadge
                  size={"2.5em"}
                  color={"grey"}
                  style={{ color: "#4078c0" }}
                  className={classes.toolicons}
                />
                <div className={classes.label}>GitHub</div>
              </div>
              <div className={classes.tools}>
                <DiNpm
                  size={"2.5em"}
                  color={"grey"}
                  style={{ color: "#cc3534" }}
                  className={classes.toolicons}
                />
                <div className={classes.label}>Npm</div>
              </div>
              <div className={classes.tools}>
                <DiCodepen
                  size={"2.5em"}
                  color={"grey"}
                  style={{ color: "#76DAFF " }}
                  className={classes.toolicons}
                />
                <div className={classes.label}>Codepen</div>
              </div>
              <div className={classes.tools}>
                <DiTerminal
                  size={"2.5em"}
                  color={"grey"}
                  style={{ color: "#fff" }}
                  className={classes.toolicons}
                />
                <div className={classes.label}>Terminal</div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.desp}>
          <div className={classes.iconSection}>
            <h2 className={classes.h2}>Tech I've Worked with</h2>
            <div className={classes.logo}>
              <div className={classes.icons}>
                <div>
                  <span className={classes.logoicons}>
                    <DiReact
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#06bcee" }}
                      className={classes[("icons", "react")]}
                    />
                  </span>
                  <div className={classes.label}>React</div>
                </div>
                <div>
                  <span className={classes.logoicons}>
                    <DiJsBadge
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#f0db4f" }}
                      className={classes[("icons", "js")]}
                    />
                  </span>
                  <div className={classes.label}>JavaScript</div>
                </div>
                <div>
                  <span className={classes.logoicons}>
                    <DiHtml5
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#FF5733" }}
                      className={classes[("icons", "html")]}
                    />
                  </span>
                  <div className={classes.label}>HTML5</div>
                </div>
                <div>
                  <span className={classes.logoicons}>
                    <DiCss3
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#264de4" }}
                      className={classes[("icons", "css")]}
                    />
                  </span>
                  <div className={classes.label}>CSS3</div>
                </div>
              </div>
              <div className={classes.icons}>
                <div>
                  <span className={classes.logoicons}>
                    <DiNodejsSmall
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#303030" }}
                      className={classes[("icons", "nodejs")]}
                    />
                  </span>
                  <div className={classes.label}>NodeJS</div>
                </div>
                <div>
                  <span className={classes.logoicons}>
                    <DiMongodb
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#4DB33D" }}
                      className={classes[("icons", "mongodb")]}
                    />
                  </span>
                  <div className={classes.label}>MongoDB</div>
                </div>
                <div>
                  <span className={classes.logoicons}>
                    <DiDjango
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#092e20" }}
                      className={classes[("icons", "python")]}
                    />
                  </span>
                  <div className={classes.label}>Django</div>
                </div>
                <div>
                  <span className={classes.logoicons}>
                    <DiBootstrap
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#563d7c" }}
                      className={classes[("icons", "python")]}
                    />
                  </span>
                  <div className={classes.label}>Bootstrap</div>
                </div>
              </div>
              <div className={classes.icons}>
                <div>
                  <span className={classes.logoicons}>
                    <DiWordpress
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#21759bs" }}
                      className={classes[("icons", "python")]}
                    />
                  </span>
                  <div className={classes.label}>Wordpress</div>
                </div>
                <div>
                  <span className={classes.logoicons}>
                    <DiPython
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#FFD43B" }}
                      className={classes[("icons", "python")]}
                    />
                  </span>
                  <div className={classes.label}>Python</div>
                </div>
                <div>
                  <span className={classes.logoicons}>
                    <DiGit
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "#f34f29 " }}
                      className={classes[("icons", "git")]}
                    />
                  </span>
                  <div className={classes.label}>Git</div>
                </div>
                <div>
                  <span className={classes.logoicons}>
                    <DiHeroku
                      size={"2.5em"}
                      color={"grey"}
                      style={{ color: "purple" }}
                      className={classes[("icons", "heroku")]}
                    />
                  </span>
                  <div className={classes.label}>Heroku</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Arrow Image */}
      <div className={classes.zio}>
        <img src={process.env.PUBLIC_URL + "/assests/down-arrow.png"} alt="" />
      </div>

      {/* //////////////cards */}
      <ProjectCard posts={projects} />
    </div>
  );
};

export default Project;
